import { combineReducers } from 'redux';
import {
  TOGGLE_UI_STATE,
  SET_SELECTED_ITEMS,
  ADD_TO_SELECTED_ITEMS,
  REMOVE_FROM_SELECTED_ITEMS,
  TOGGLE_SELECTED_ITEM,
} from '../actions/ui';

const toggles = (
  state = {
    ids: false,
    syllables: false,
    stresses: false,
    // sidebarOpen: false,
    // selectedItems: {},
  },
  action,
) => {
  switch (action.type) {
  case TOGGLE_UI_STATE:
    return {
      ...state,
      [action.name]: !state[action.name],
    };

  default:
    return state;
  }
};

const selectedItems = (state = {}, action) => {
  switch (action.type) {
  case SET_SELECTED_ITEMS:
    return { ...action.modelIdMapping };

  case TOGGLE_SELECTED_ITEM: {
    let ids = [...(state[action.modelType] || [])];
    if (ids.indexOf(action.id) === -1) {
      ids.push(action.id);
    } else {
      ids = ids.filter(id => id !== action.id);
    }
    return {
      ...state,
      [action.modelType]: ids,
    };
  }

  case ADD_TO_SELECTED_ITEMS:
    return {
      ...state,
      [action.modelType]: [...state[action.modelType], action.id],
    };
  case REMOVE_FROM_SELECTED_ITEMS:
    return {
      ...state,
      [action.modelType]: state[action.modelType].filter(id => id !== action.id),
    };

  default:
    return state;
  }
};

const ui = combineReducers({
  toggles,
  selectedItems,
});
export default ui;



// WEBPACK FOOTER //
// ./src/reducers/ui.js